import { View } from "./View";

export const ReportsBreakdown = (props: any) => {
  return (
    <View
      queryStringTabs={props.queryStringTabs}
      title={props.title}
      subtitle={props.subtitle}
      summary={props.summary}
      detail1={props.detail1}
      detail2={props.detail2}
      detail3={props.detail3}
      detail1num={props.detail1num}
      detail2num={props.detail2num}
      detail3num={props.detail3num}
      subtitle2={props.subtitle2}
      subtitle2num={props.subtitle2num}
      subtitle3={props.subtitle3}
      subtitle3summary={props.subtitle3summary}
      row1a={props.row1a}
      row1b={props.row1b}
      row1c={props.row1c}
      row2b={props.row2b}
      row2c={props.row2c}
      row3a={props.row3a}
      row3b={props.row3b}
      row3d={props.row3d}
      row3c={props.row3c}
      row4b={props.row4b}
      row4c={props.row4c}
      row5b={props.row5b}
      row5c={props.row5c}
      balanceactivity={props.balanceactivity}
      activitynum={props.activitynum}
      activityamount={props.activityamount}
      subtitle4={props.subtitle4}
      subtitle4summary={props.subtitle4summary}
      row6a={props.row6a}
      row6b={props.row6b}
      row6c={props.row6c}
      row7a={props.row7a}
      row7b={props.row7b}
    />
  );
};
